import { render } from "./userAgreement.vue?vue&type=template&id=3326b09c&scoped=true"
import script from "./userAgreement.vue?vue&type=script&lang=js"
export * from "./userAgreement.vue?vue&type=script&lang=js"

import "./userAgreement.vue?vue&type=style&index=0&id=3326b09c&scoped=true&lang=css"

import exportComponent from "F:\\webWork\\demo\\h5sdk2\\h5sdk3.muugame.com\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3326b09c"]])

export default __exports__